const GreaterThanOrEqual = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M6.5 2.27 20 10.14 6.5 18l-1-1.73 10.53-6.13L5.5 4l1-1.73M20 20v2H5v-2h15Z" />
  </svg>
)
export default GreaterThanOrEqual
